import { sparkletts as sparklettsDomain } from 'containers/Landing/constants';

export const fetchSite = async (payload, domain, contentfulClient) => {
  const { slug } = domain;
  const params = {
    ...payload,
    query: { slug },
  };

  return contentfulClient.getEntries(params);
};

export const fetchPage = async (contentfulClient, key) => {
  const { page, slug: siteSlug } = sparklettsDomain;

  // FIXME seems like a hack, fix underlying issue
  // hint: log when this is called & nav to equipment manuals
  if (key === 'support') return null;

  const options = {
    contentType: 'page',
    query: {
      slug: page[key] || key,
      'site.sys.contentType.sys.id': 'domain',
      'site.fields.slug': siteSlug,
    },
  };

  return contentfulClient.getEntries(options);
};

export const fetchProductCards = async (itemNumbers, contentfulClient) => {
  const params = {
    contentType: 'productCard',
    query: {
      'itemNumber[in]': itemNumbers.join(','),
    },
    additionalQueryParams: {
      select: 'fields.itemNumber,fields.images,fields.title',
    },
  };
  return contentfulClient.getEntries(params);
};

export const fetchProducts = async (
  itemNumbers,
  contentfulClient,
  // onlyImages = false,
) => {
  // TODO: Ignoring onlyImages flag for now, since the code below does not make sense
  const onlyImages = false;
  const params = {
    contentType: 'product',
    query: {
      'itemNumber[in]': itemNumbers.join(','),
    },
    additionalQueryParams: {
      select: `fields.specialNotes,fields.isPPS,fields.isBestSeller,fields.name,fields.itemNumber,fields.images,fields.size,fields.brand,fields.productType,fields.category,fields.isOneTimePurchase,fields.slug${
        onlyImages ? '' : ',fields.description,fields.count'
      }`,
    },
  };

  return contentfulClient.getEntries(params);
};

export const fetchProductBySlug = async (slug, contentfulClient) => {
  const params = {
    contentType: 'product',
    query: {
      slug,
    },
    additionalQueryParams: {
      select: 'fields.itemNumber',
    },
  };

  return contentfulClient.getEntries(params);
};

export const fetchProductByItemNumber = async (
  itemNumber,
  contentfulClient,
) => {
  const params = {
    contentType: 'product',
    query: {
      itemNumber,
    },
    additionalQueryParams: {
      select: 'fields.itemNumber',
    },
  };

  return contentfulClient.getEntries(params);
};

export const fetchProductTypes = async (contentfulClient) =>
  contentfulClient.getEntries({
    contentType: 'productType',
  });

export const searchFAQ = async (domain, contentfulClient, query) => {
  const options = {
    contentType: 'faqItem',
    additionalQueryParams: {
      query,
    },
  };

  return contentfulClient.getEntries(options);
};

export const fetchPromotionAssets = async (contentfulClient) => {
  const query = {
    'fields.title[in]': '17232503,41000561',
    select: 'fields.title,fields.file',
  };
  return contentfulClient.getAssets(query);
};

export const fetchNewFeatureVideo = async (contentfulClient) => {
  const query = {
    'fields.title[in]': 'New Feature Tour 11.10',
    select: 'fields.file,fields.description',
  };
  return contentfulClient.getAssets(query);
};

export const fetchImage = async (contentfulClient, title) => {
  const query = {
    'fields.title[in]': title,
    select: 'fields.file,fields.description',
  };
  return contentfulClient.getAssets(query);
};

export const fetchEntry = async (contentfulClient, payload) =>
  contentfulClient.getEntry(payload);

export const fetchEntryByTitle = async (contentfulClient, { type, title }) => {
  const options = {
    contentType: type,
    additionalQueryParams: {
      'fields.entryTitle[in]': title,
    },
  };
  const entries = await contentfulClient.getEntries(options);
  if (entries.items.length > 0) return entries.items[0];
  return null;
};

export const fetchAsset = async (contentfulClient, title) =>
  contentfulClient.getAssets({
    'fields.title[in]': title,
    select: 'fields.file,fields.description',
  });

export const fetchJSONData = async (contentfulClient, title) => {
  const options = {
    contentType: 'jsonData',
    additionalQueryParams: {
      'fields.entryTitle[in]': title,
    },
  };
  return contentfulClient.getEntries(options);
};

export const fetchBrandedVariables = async (contentfulClient, brand) =>
  fetchJSONData(contentfulClient, `Acquisition > Branded Variables > ${brand}`);
